import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MarvelChampionsModule } from './marvel-champions/marvel-champions.module';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/mc',
    pathMatch:'full'
  },
  /* {
    path: 'mc',
    component: MarvelChampionsComponent
  } */
  {
    path: 'mc',
    loadChildren: () => MarvelChampionsModule// './marvel-champions/marvel-champions.module#MarvelChampionsModule'
  },
  /* {
    path: 'gh',
    loadChildren: 'app/gloomhaven/gloomhaven.module#GloomhavenModule'
  } */
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }